import { render, staticRenderFns } from "./CollapseMenuItem.vue?vue&type=template&id=b3f0867a&scoped=true"
import script from "./CollapseMenuItem.vue?vue&type=script&lang=ts"
export * from "./CollapseMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./CollapseMenuItem.vue?vue&type=style&index=0&id=b3f0867a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f0867a",
  null
  
)

export default component.exports